import BpResourceEntry from "./single";
import BpResourceEntries from "./directive";

const modul = angular
    .module("BpResourceEntriesModule", [])
    .directive("bpResourceEntries", BpResourceEntries)
    .directive("bpResourceEntry", BpResourceEntry);

export default modul.name;
